module.exports = __webpack_public_path__ + "static/img/4-title.16e1fa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/4-title.png
// module id = W+nt
// module chunks = 0